import React from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

export default function Menu() {

return  (

    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4 }}>
       <div> 
        <Button variant="contained" size="large" href="./map">
          Mapa por Vendedor
        </Button>
        </div>
        <div>
        <Button variant="contained" size="large" href="./canal">
          Mapa por Supervidor
        </Button>
      </div>
    </Box>
  );
}
